import "./sass/style.scss"
// import "./js/customizer"
import "./js/navigation"
import "./js/skip-link-focus-fix"
import 'bootstrap'
import $ from 'jquery';
import 'slick-carousel';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';



$(document).ready(function(){
    $('.gallery').slick({
        dots: true,
        appendDots: $('.gallery'),
    });
    
    $('.brands').slick({
        dots: false,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false
        // responsive: [
        //     {
        //         breakpoint: 1024,
        //         settings: {
        //             slidesToShow: 3,
        //             slidesToScroll: 3,
        //             infinite: true,
        //             dots: true
        //         }
        //     },
        //     {
        //         breakpoint: 600,
        //         settings: {
        //             slidesToShow: 2,
        //             slidesToScroll: 2
        //         }
        //     },
        //     {
        //         breakpoint: 480,
        //         settings: {
        //             slidesToShow: 1,
        //             slidesToScroll: 1
        //         }
        //     }
        //     // You can unslick at a given breakpoint now by adding:
        //     // settings: "unslick"
        //     // instead of a settings object
        // ]
    });
    
    var xsBreakpoint = 576;

    updateAllSigns();
    $(window).resize(function(){
        updateAllSigns();
    });
    
    $('.expandable-toggle').click(function(e){
        e.preventDefault();
        toggleWidget($(this))
    })

    $(document).on('facetwp-loaded', function() {
        // Scroll to the top of the page after the page is refreshed
        let count = Object.keys(FWP.facets).reduce(function (previous, key) {
            if(key === 'price' && FWP.facets[key].length) return previous + 1;
            
            return previous + FWP.facets[key].length;
        }, 0);
        
        $('.filter-count').html(count);
        
        if(count){
            $('.filter-count').addClass('badge-info');
            $('.filter-count').removeClass('badge-light');
        } else {
            $('.filter-count').removeClass('badge-info');
            $('.filter-count').addClass('badge-light');
        }
    });
    
    function updateAllSigns(){
        $('.expandable').each(function(index, el){
            updateSign($(el))
        });
    }
    
    function updateSign($toggler){
        var id = $toggler.data('target');
        var $widget = $toggler.closest('.expandable');
        var $icon = $widget.find('.expandable-icon');

        var $showHide = $(id);
        if($showHide.is(":visible")){
            $icon.html('-');
        } else {
            $icon.html('+');
        }
    }
    
    function toggleWidget($toggler){
        if($(window).width() < xsBreakpoint){
            var $showHide = $($toggler.data('target'));
            $showHide.slideToggle(function(){
                updateSign($toggler);
            });
        }
    }
});

